"use strict";

const allCountries = [
    ["Afghanistan (‫افغانستان‬‎)", "af", "+93", "004", "AFN", "Afghani"],
    ["Åland Islands", "ax", "+358", "248", "EUR", "Euro"],
    ["Albania (Shqipëri)", "al", "+355", "008", "ALL", "Lek"],
    ["Algeria (‫الجزائر‬‎)", "dz", "+213", "012", "DZD", "Algerian Dinar"],
    ["American Samoa", "as", "+1684", "016", "USD", "US Dollar"],
    ["Andorra", "ad", "+376", "020", "EUR", "Euro"],
    ["Angola", "ao", "+244", "024", "AOA", "Kwanza"],
    ["Anguilla", "ai", "+1264", "660", "XCD", "East Caribbean Dollar"],
    ["Antarctica", "aq", "+672", "010", null, null],
    ["Antigua and Barbuda", "ag", "+1268", "028", "XCD", "East Caribbean Dollar"],
    ["Argentina", "ar", "+54", "032", "ARS", "Argentine Peso"],
    ["Armenia (Հայաստան)", "am", "+374", "051", "AMD", "Armenian Dram"],
    ["Aruba", "aw", "+297", "533", "AWG", "Aruban Florin"],
    ["Australia", "au", "+61", "036", "AUD", "Australian Dollar"],
    ["Austria (Österreich)", "at", "+43", "040", "EUR", "Euro"],
    ["Azerbaijan (Azərbaycan)", "az", "+994", "031", "AZN", "Azerbaijan Manat"],
    ["Bahamas", "bs", "+1242", "044", "BSD", "Bahamian Dollar"],
    ["Bahrain (‫البحرين‬‎)", "bh", "+973", "048", "BHD", "Bahraini Dinar"],
    ["Bangladesh (বাংলাদেশ)", "bd", "+880", "050", "BDT", "Taka"],
    ["Barbados", "bb", "+1246", "052", "BBD", "Barbados Dollar"],
    ["Belarus (Беларусь)", "by", "+375", "112", "BYN", "Belarusian Ruble"],
    ["Belgium (België)", "be", "+32", "056", "EUR", "Euro"],
    ["Belize", "bz", "+501", "084", "BZD", "Belize Dollar"],
    ["Benin (Bénin)", "bj", "+229", "204", "XOF", "CFA Franc BCEAO"],
    ["Bermuda", "bm", "+1441", "060", "BMD", "Bermudian Dollar"],
    ["Bhutan (འབྲུག)", "bt", "+975", "064", "INR", "Indian Rupee"],
    ["Bolivia", "bo", "+591", "068", "BOB", "Boliviano"],
    ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "+387", "070", "BAM", "Convertible Mark"],
    ["Botswana", "bw", "+267", "072", "BWP", "Pula"],
    ["Bouvet Island", "bv", "+47", "074", "NOK", "Norwegian Krone"],
    ["Brazil (Brasil)", "br", "+55", "076", "BRL", "Brazilian Real"],
    ["British Indian Ocean Territory", "io", "+246", "086", "USD", "US Dollar"],
    ["British Virgin Islands", "vg", "+1284", "092", "USD", "US Dollar"],
    ["Brunei", "bn", "+673", "096", "BND", "Brunei Dollar"],
    ["Bulgaria (България)", "bg", "+359", "100", "BGN", "Bulgarian Lev"],
    ["Burkina Faso", "bf", "+226", "854", "XOF", "CFA Franc BCEAO"],
    ["Burundi (Uburundi)", "bi", "+257", "108", "BIF", "Burundi Franc"],
    ["Cambodia (កម្ពុជា)", "kh", "+855", "116", "KHR", "Riel"],
    ["Cameroon (Cameroun)", "cm", "+237", "120", "XAF", "CFA Franc BEAC"],
    [
        "Canada",
        "ca",
        "+1",
        "124",
        "CAD",
        "Canadian Dollar"
    ],
    ["Cape Verde (Kabu Verdi)", "cv", "+238", "132", "CVE", "Cabo Verde Escudo"],
    ["Caribbean Netherlands", "bq", "+599", "535", ["USD", "EUR"], ["US Dollar", "Euro"]],
    ["Cayman Islands", "ky", "+1345", "136", "KYD", "Cayman Islands Dollar"],
    [
        "Central African Republic (République centrafricaine)",
        "cf",
        "+236",
        "140",
        "XAF",
        "CFA Franc BEAC"
    ],
    ["Chad (Tchad)", "td", "+235", "148", "XAF", "CFA Franc BEAC"],
    ["Chile", "cl", "+56", "152", "CLP", "Chilean Peso"],
    ["China (中国)", "cn", "+86", "156", "CNY", "Yuan Renminbi"],
    ["Christmas Island", "cx", "+61", "162", "AUD", "Australian Dollar"],
    ["Cocos (Keeling) Islands", "cc", "+61", "166", "AUD", "Australian Dollar"],
    ["Colombia", "co", "+57", "170", "COP", "Colombian Peso"],
    ["Comoros (‫جزر القمر‬‎)", "km", "+269", "174", "KMF", "Comorian Franc"],
    [
        "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
        "cd",
        "+243",
        "180",
        "CDF",
        "Congolese Franc"
    ],
    ["Congo (Republic) (Congo-Brazzaville)", "cg", "+242", "178", "XAF", "CFA Franc BEAC"],
    ["Cook Islands", "ck", "+682", "184", "NZD", "New Zealand Dollar"],
    ["Costa Rica", "cr", "+506", "188", "CRC", "Costa Rican Colon"],
    ["Côte d’Ivoire", "ci", "+225", "184", "XOF", "CFA Franc BCEAO"],
    ["Croatia (Hrvatska)", "hr", "+385", "191", "HRK", "Kuna"],
    ["Cuba", "cu", "+53", "192", "CUP", "Cuban Peso"],
    ["Curaçao", "cw", "+599", "531", "ANG", "Netherlands Antillean Guilder"],
    ["Cyprus (Κύπρος)", "cy", "+357", "196", "EUR", "Euro"],
    ["Czech Republic (Česká republika)", "cz", "+420", "203", "CZK", "Czech Koruna"],
    ["Denmark (Danmark)", "dk", "+45", "208", "DKK", "Danish Krone"],
    ["Djibouti", "dj", "+253", "262", "DJF", "Djibouti Franc"],
    ["Dominica", "dm", "+1767", "212", "XCD", "East Caribbean Dollar"],
    [
        "Dominican Republic (República Dominicana)",
        "do",
        "+1",
        "214",
        "DOP",
        "Dominican Peso"
    ],
    ["Ecuador", "ec", "+593", "218", "USD", "US Dollar"],
    ["Egypt (‫مصر‬‎)", "eg", "+20", "818", "EGP", "Egyptian Pound"],
    ["El Salvador", "sv", "+503", "222", "SVC", "El Salvador Colon"],
    ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "+240", "226", "XAF", "CFA Franc BEAC"],
    ["Eritrea", "er", "+291", "232", "ERN", "Nakfa"],
    ["Estonia (Eesti)", "ee", "+372", "233", "EUR", "Euro"],
    ["Ethiopia", "et", "+251", "2310", "SZL", "Lilangeni", "ETB", "Ethiopian Birr"],
    ["Falkland Islands (Islas Malvinas)", "fk", "+500", "238", "FKP", "Falkland Islands Pound"],
    ["Faroe Islands (Føroyar)", "fo", "+298", "234", "DKK", "Danish Krone"],
    ["Fiji", "fj", "+679", "242", "FJD", "Fiji Dollar"],
    ["Finland (Suomi)", "fi", "+358", "246", "EUR", "Euro"],
    ["France", "fr", "+33", "250", "EUR", "Euro"],
    ["French Guiana (Guyane française)", "gf", "+594", "254", "EUR", "Euro"],
    ["French Polynesia (Polynésie française)", "pf", "+689", "258", "XPF", "CFP Franc"],
    ["French Southern and Antarctic Lands", "tf", "+262", "260", "EUR", "Euro"],
    ["Gabon", "ga", "+241", "266", "XAF", "CFA Franc BEAC"],
    ["Gambia", "gm", "+220", "270", "GMD", "Dalasi"],
    ["Georgia (საქართველო)", "ge", "+995", "268", "GEL", "Lari"],
    ["Germany (Deutschland)", "de", "+49", "276", "EUR", "Euro"],
    ["Ghana (Gaana)", "gh", "+233", "288", "GHS", "Ghana Cedi"],
    ["Gibraltar", "gi", "+350", "292", "GIP", "Gibraltar Pound"],
    ["Greece (Ελλάδα)", "gr", "+30", "300", "EUR", "Euro"],
    ["Greenland (Kalaallit Nunaat)", "gl", "+299", "304", "DKK", "Danish Krone"],
    ["Grenada", "gd", "+1473", "308", "XCD", "East Caribbean Dollar"],
    ["Guadeloupe", "gp", "+590", "312", "EUR", "Euro"],
    ["Guam", "gu", "+1671", "316", "USD", "US Dollar"],
    ["Guatemala", "gt", "+502", "320","GTQ", "Quetzal"],
    ["Guernsey", "gg", "+44", "831", "GBP", "Pound Sterling"],
    ["Guinea (Guinée)", "gn", "+224", "324", "GNF", "Guinean Franc"],
    ["Guinea-Bissau (Guiné Bissau)", "gw", "+245", "624", "XOF", "CFA Franc BCEAO"],
    ["Guyana", "gy", "+592", "328", "GYD", "Guyana Dollar"],
    ["Haiti", "ht", "+509", "332", "HTG", "Gourde"],
    ["Heard Island and McDonald Islands", "hm", "+672", "334", "AUD", "Australian Dollar"],
    ["Honduras", "hn", "+504", "340", "HNL", "Lempira"],
    ["Hong Kong (香港)", "hk", "+852", "344", "HKD", "Hong Kong Dollar"],
    ["Hungary (Magyarország)", "hu", "+36", "348", "HUF", "Forint"],
    ["Iceland (Ísland)", "is", "+354", "352", "ISK", "Iceland Krona"],
    ["India (भारत)", "in", "+91", "356", "INR", "Indian Rupee"],
    ["Indonesia", "id", "+62", "360", "IDR", "Rupiah"],
    ["Iran (‫ایران‬‎)", "ir", "+98", "364", "IRR", "Iranian Rial"],
    ["Iraq (‫العراق‬‎)", "iq", "+964", "368", "IQD", "Iraqi Dinar"],
    ["Ireland", "ie", "+353", "372", "EUR", "Euro"],
    ["Isle of Man", "im", "+44", "833", "GBP", "Pound Sterling"],
    ["Israel (‫ישראל‬‎)", "il", "+972", "376", "ILS", "New Israeli Sheqel"],
    ["Italy (Italia)", "it", "+39", "380", "EUR", "Euro"],
    ["Jamaica", "jm", "+1876", "388", "JMD", "Jamaican Dollar"],
    ["Japan (日本)", "jp", "+81", "392", "JPY", "Yen"],
    ["Jersey", "je", "+44", "832", "GBP", "Pound Sterling"],
    ["Jordan (‫الأردن‬‎)", "jo", "+962", "400", "JOD", "Jordanian Dinar"],
    ["Kazakhstan (Казахстан)", "kz", "+7", "398", "KZT", "Tenge"],
    ["Kenya", "ke", "+254", "404", "KES", "Kenyan Shilling"],
    ["Kiribati", "ki", "+686", "296", "AUD", "Australian Dollar"],
    ["Kosovo", "xk", "+383", "926", "EUR", "Euro"],
    ["Kuwait (‫الكويت‬‎)", "kw", "+965", "414", "KWD", "Kuwaiti Dinar"],
    ["Kyrgyzstan (Кыргызстан)", "kg", "+996", "417", "KGS", "Som"],
    ["Laos (ລາວ)", "la", "+856", "418", "LAK", "Lao Kip"],
    ["Latvia (Latvija)", "lv", "+371", "428", "EUR", "Euro"],
    ["Lebanon (‫لبنان‬‎)", "lb", "+961", "422", "LBP", "Lebanese Pound"],
    ["Lesotho", "ls", "+266", "426", "LSL", "Loti"],
    ["Liberia", "lr", "+231", "430", "LRD", "Liberian Dollar"],
    ["Libya (‫ليبيا‬‎)", "ly", "+218", "434", "LYD", "Libyan Dinar"],
    ["Liechtenstein", "li", "+423", "438", "CHF", "Swiss Franc"],
    ["Lithuania (Lietuva)", "lt", "+370", "440", "EUR", "Euro"],
    ["Luxembourg", "lu", "+352", "442", "EUR", "Euro"],
    ["Macau (澳門)", "mo", "+853", "446", "MOP", "Pataca"],
    ["Macedonia (FYROM) (Македонија)", "mk", "+389", "807", "MKD", "Denar"],
    ["Madagascar (Madagasikara)", "mg", "+261", "450", "MGA", "Malagasy Ariary"],
    ["Malawi", "mw", "+265", "454", "MWK", "Malawi Kwacha"],
    ["Malaysia", "my", "+60", "458", "MYR", "Malaysian Ringgit"],
    ["Maldives", "mv", "+960", "462", "MVR", "Rufiyaa"],
    ["Mali", "ml", "+223", "466", "XOF", "CFA Franc BCEAO"],
    ["Malta", "mt", "+356", "470", "EUR", "Euro"],
    ["Marshall Islands", "mh", "+692", "584", "USD", "US Dollar"],
    ["Martinique", "mq", "+596", "474", "EUR", "Euro"],
    ["Mauritania (‫موريتانيا‬‎)", "mr", "+222", "478", "MRU", "Ouguiya"],
    ["Mauritius (Moris)", "mu", "+230", "480", "MUR", "Mauritius Rupee"],
    ["Mayotte", "yt", "+262", "175", "EUR", "Euro"],
    ["Mexico (México)", "mx", "+52", "484", "MXN", "Mexican Peso"],
    ["Micronesia", "fm", "+691", "583", "USD", "US Dollar"],
    ["Moldova (Republica Moldova)", "md", "+373", "498", "MDL", "Moldovan Leu"],
    ["Monaco", "mc", "+377", "492", "EUR", "Euro"],
    ["Mongolia (Монгол)", "mn", "+976", "496", "MNT", "Tugrik"],
    ["Montenegro (Crna Gora)", "me", "+382", "499", "EUR", "Euro"],
    ["Montserrat", "ms", "+1664", "500", "XCD", "East Caribbean Dollar"],
    ["Morocco (‫المغرب‬‎)", "ma", "+212", "504", "MAD", "Moroccan Dirham"],
    ["Mozambique (Moçambique)", "mz", "+258", "508", "MZN", "Mozambique Metical"],
    ["Myanmar (Burma) (မြန်မာ)", "mm", "+95", "104", "MMK", "Kyat"],
    ["Namibia (Namibië)", "na", "+264", "516", "NAD", "Namibia Dollar"],
    ["Nauru", "nr", "+674", "520", "AUD", "Australian Dollar"],
    ["Nepal (नेपाल)", "np", "+977", "524", "NPR", "Nepalese Rupee"],
    ["Netherlands (Nederland)", "nl", "+31", "528", "EUR", "Euro"],
    ["New Caledonia (Nouvelle-Calédonie)", "nc", "+687", "540", "XPF", "CFP Franc"],
    ["New Zealand", "nz", "+64", "554", "NZD", "New Zealand Dollar"],
    ["Nicaragua", "ni", "+505", "558", "NIO", "Cordoba Oro"],
    ["Niger (Nijar)", "ne", "+227", "562", "XOF", "CFA Franc BCEAO"],
    ["Nigeria", "ng", "+234", "566", "NGN", "Naira"],
    ["Niue", "nu", "+683", "570", "NZD", "New Zealand Dollar"],
    ["Norfolk Island", "nf", "+672", "574", "AUD", "Australian Dollar"],
    ["North Korea (조선 민주주의 인민 공화국)", "kp", "+850", "408", "KPW", "North Korean won"],
    ["Northern Mariana Islands", "mp", "+1670", "580", "USD", "US Dollar"],
    ["Norway (Norge)", "no", "+47", "578", "NOK", "Norwegian Krone"],
    ["Oman (‫عُمان‬‎)", "om", "+968", "512", "OMR", "Rial Omani"],
    ["Pakistan (‫پاکستان‬‎)", "pk", "+92", "586", "PKR", "Pakistan Rupee"],
    ["Palau", "pw", "+680", "585", "USD", "US Dollar"],
    ["Palestine (‫فلسطين‬‎)", "ps", "+970", "275", null, null],
    ["Panama (Panamá)", "pa", "+507", "591", "PAB", "Balboa"],
    ["Papua New Guinea", "pg", "+675", "598", "PGK", "Kina"],
    ["Paraguay", "py", "+595", "600", "PYG", "Guarani"],
    ["Peru (Perú)", "pe", "+51", "604", "PEN", "Sol"],
    ["Philippines", "ph", "+63", "608", "PHP", "Philippine Peso"],
    ["Pitcairn Islands", "pn", "+64", "612", "NZD", "New Zealand Dollar"],
    ["Poland (Polska)", "pl", "+48", "616", "PNL", "Zloty"],
    ["Portugal", "pt", "+351", "620", "EUR", "Euro"],
    ["Puerto Rico", "pr", "+1", "630", "USD", "US Dollar"],
    ["Qatar (‫قطر‬‎)", "qa", "+974", "634", "QAR", "Qatari Rial"],
    ["Réunion (La Réunion)", "re", "+262", "638", "EUR", "Euro"],
    ["Romania (România)", "ro", "+40", "642", "RON", "Romanian Leu"],
    ["Russia (Россия)", "ru", "+7", "643", "RUB", "Russian Ruble"],
    ["Rwanda", "rw", "+250", "646", "RWF", "Rwanda Franc"],
    ["Saint Barthélemy (Saint-Barthélemy)", "bl", "+590", "652", "EUR", "Euro"],
    ["Saint Helena", "sh", "+290", "564", "SHP", "Saint Helena Pound"],
    ["Saint Kitts and Nevis", "kn", "+1869", "659", "XCD", "East Caribbean Dollar"],
    ["Saint Lucia", "lc", "+1758", "662", "XCD", "East Caribbean Dollar"],
    ["Saint Martin (Saint-Martin (partie française))", "mf", "+590", "663", "EUR", "Euro"],
    ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "+508", "666", "EUR", "Euro"],
    ["Saint Vincent and the Grenadines", "vc", "+1784", "670", "XCD", "East Caribbean Dollar"],
    ["Samoa", "ws", "+685", "882", "WST", "Tala"],
    ["San Marino", "sm", "+378", "674", "EUR", "Euro"],
    ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "+239", "678", "STN", "Dobra"],
    [
        "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
        "sa",
        "+966",
        "682",
        "SAR",
        "Saudi Riyal"
    ],
    ["Senegal (Sénégal)", "sn", "+221", "686", "XOF", "CFA Franc BCEAO"],
    ["Serbia (Србија)", "rs", "+381", "688", "RSD", "Serbian Dinar"],
    ["Seychelles", "sc", "+248", "690", "SCR", "Seychelles Rupee"],
    ["Sierra Leone", "sl", "+232", "694", "SLL", "Leone"],
    ["Singapore", "sg", "+65", "702", "SGD", "Singapore Dollar"],
    ["Sint Maarten", "sx", "+1721", "534", "ANG", "Netherlands Antillean Guilder"],
    ["Slovakia (Slovensko)", "sk", "+421", "703", "EUR", "Euro"],
    ["Slovenia (Slovenija)", "si", "+386", "705", "EUR", "Euro"],
    ["Solomon Islands", "sb", "+677", "090", "SBD", "Solomon Islands Dollar"],
    ["Somalia (Soomaaliya)", "so", "+252", "706", "SOS", "Somali Shilling"],
    ["South Africa", "za", "+27", "710", "ZAR", "Rand"],
    ["South Georgia and the South Sandwich Islands", "gs", "+500", "239", null, null],
    ["South Korea (대한민국)", "kr", "+82", "410", "KRW", "South Korean won"],
    ["South Sudan (‫جنوب السودان‬‎)", "ss", "+211", "728", "SSP", "South Sudanese Pound"],
    ["Spain (España)", "es", "+34", "724", "EUR", "Euro"],
    ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "+94", "144", "LKR", "Sri Lanka Rupee"],
    ["Sudan (‫السودان‬‎)", "sd", "+249", "729", "SDG", "Sudanese Poun"],
    ["Suriname", "sr", "+597", "740", "SRD", "Surinam Dollar"],
    ["Svalbard and Jan Mayen", "sj", "+47", "744", "NOK", "Norwegian Krone"],
    ["Swaziland", "sz", "+268", "748", "SZL", "Swazi lilangeni"],
    ["Sweden (Sverige)", "se", "+46", "752", "SEK", "Swedish Krona"],
    ["Switzerland (Schweiz)", "ch", "+41", "756", "CHF", "Swiss Franc"],
    ["Syria (‫سوريا‬‎)", "sy", "+963", "760", "SYR", "Syrian Pound"],
    ["Taiwan (台灣)", "tw", "+886", "158", "TWD", "New Taiwan Dollar"],
    ["Tajikistan", "tj", "+992", "762", "TJS", "Somoni"],
    ["Tanzania", "tz", "+255", "834", "TZS", "Tanzanian Shilling"],
    ["Thailand (ไทย)", "th", "+66", "764", "THB", "Baht"],
    ["Timor-Leste", "tl", "+670", "626", "USD", "US Dollar"],
    ["Togo", "tg", "+228", "768", "XOF", "CFA Franc BCEAO"],
    ["Tokelau", "tk", "+690", "772", "NZD", "New Zealand Dollar"],
    ["Tonga", "to", "+676", "776", "TOP", "Pa’anga"],
    ["Trinidad and Tobago", "tt", "+1868", "780", "TTD", "Trinidad and Tobago Dollar"],
    ["Tunisia (‫تونس‬‎)", "tn", "+216", "788", "TND", "Tunisian Dinar"],
    ["Turkey (Türkiye)", "tr", "+90", "792", "TRY", "Turkish Lira"],
    ["Turkmenistan", "tm", "+993", "795", "TMT", "Turkmenistan New Manat"],
    ["Turks and Caicos Islands", "tc", "+1649", "796", "USD", "US Dollar"],
    ["Tuvalu", "tv", "+688", "798", "AUD", "Australian Dollar"],
    ["U.S. Virgin Islands", "vi", "+1340", "850", "USD", "US Dollar"],
    ["Uganda", "ug", "+256", "800", "UGX", "Uganda Shilling"],
    ["Ukraine (Україна)", "ua", "+380", "804", "UAH", "Hryvnia"],
    [
        "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
        "ae",
        "+971",
        "784",
        "AED",
        "UAE Dirham"
    ],
    ["United Kingdom", "gb", "+44", "826", "GBP", "Pound Sterling"],
    ["United States", "us", "+1", "840", "USD", "US Dollar"],
    ["United States Minor Outlying Islands", "um", "+1", "581", "USD", "US Dollar"],
    ["Uruguay", "uy", "+598", "858", "UYU", "Peso Uruguayo"],
    ["Uzbekistan (Oʻzbekiston)", "uz", "+998", "860", "UZS", "Uzbekistan Sum"],
    ["Vanuatu", "vu", "+678", "548", "VUV", "Vatu"],
    ["Vatican City (Città del Vaticano)", "va", "+39" ,"336", "EUR", "Euro"],
    ["Venezuela", "ve", "+58", "862", "VES", "Bolívar Soberano"],
    ["Vietnam (Việt Nam)", "vn", "+84", "704", "VND", "Dong"],
    ["Wallis and Futuna", "wf", "+681", "876", "XPF", "CFP Franc"],
    ["Western Sahara", "eh", "+212", "732", "MAD", "Moroccan Dirham"],
    ["Yemen (‫اليمن‬‎)", "ye", "+967", "887", "YER", "Yemeni Rial"],
    ["Zambia", "zm", "+260", "894", "ZMW", "Zambian Kwacha"],
    ["Zimbabwe", "zw", "+263", "716", "ZWL", "Zimbabwe Dollar"],
];

// arrays in object to be provided to antd design select (https://ant.design/components/select/) to build options

const countriesData = [];
const dialCodeValue = [];
const numericCodeValue = [];

for (let i = 0; i < allCountries.length; i++) {
    let item = allCountries[i];
    countriesData.push({
        countryName: item[0],
        id: item[1],
        dialCode: item[2],
        countryCode: item[3],
        currencyCode: item[4],
        currencyName: item[5]
    });
    dialCodeValue.push({
        title: item[0],
        id: item[1],
        value: item[2],
        numericCode: item[3]
    });
    numericCodeValue.push({
        title: item[0],
        id: item[1],
        dialCode: item[2],
        value: item[3],
    })
}

module.exports = {
    countriesData: countriesData,
    dialCodeValue: dialCodeValue,
    numericCodeValue: numericCodeValue
};